import { ComponentPropsWithoutRef, Fragment } from "react";

import { cn } from "@utils/tailwind.util";
import { openDocumentSearch } from "@utils/navigation.util";

// Formats that in-app document viewer (PSPDFKit) can render. Used to decide
// whether to intercept an AI-context link and route it to /documents.
const VIEWABLE_DOCUMENT_FORMATS = ["pdf", "docx", "doc", "xls", "xlsx", "ppt", "pptx", "xlsm"];

export function AnchorComponent(props: ComponentPropsWithoutRef<"a">) {
  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    const href = props.href || "";

    if (!href.startsWith("http")) return;

    const url = new URL(href);
    const extension = url.pathname.split(".").pop();

    if (!VIEWABLE_DOCUMENT_FORMATS.includes(extension?.toLowerCase() || "")) return;

    event.preventDefault();
    openDocumentSearch(props.children as string);
  }

  return (
    <a
      {...props}
      onClick={handleClick}
      className={cn("text-action-primary", props.className)}
      target="_blank"
      rel="noreferrer noopener"
    />
  );
}
